import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import 'moment';

function LoadingSpinner(props) {
  var pageLoader = props.pageLoader,
    sectionLoader = props.sectionLoader,
    message = props.message,
    className = props.className,
    messageMuted = props.messageMuted,
    fullViewport = props.fullViewport;
  var size = props.size;
  var allowedSizes = ['normal', 'small', 'tiny'];
  size = allowedSizes.some(function (validSize) {
    return validSize === size;
  }) ? "bf-spinner-size-".concat(size) : '';
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-spinner-wrapper\n            ".concat(size, "\n            ").concat(pageLoader ? 'bf-page-spinner-wrapper' : '', "\n            ").concat(sectionLoader ? 'bf-section-spinner-wrapper' : '', "\n            ").concat(fullViewport ? 'bf-full-viewport-spinner-wrapper' : '', "\n            ").concat(className)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-spinner"
  }), message ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-spinner-message ".concat(messageMuted ? 'bf-text-muted' : '')
  }, message) : null);
}
LoadingSpinner.defaultProps = {
  pageLoader: false,
  message: '',
  className: '',
  sectionLoader: false,
  fullViewport: false,
  size: 'normal',
  messageMuted: false
};
LoadingSpinner.propTypes = {
  /**
  LoadingSpinner with large margins
   */
  pageLoader: PropTypes.bool,
  /**
  LoadingSpinner with medium margins
   */
  sectionLoader: PropTypes.bool,
  /**
  Full viewport overlay with LoadingSpinner in the center
   */
  fullViewport: PropTypes.bool,
  /**
  LoadingSpinner message
   */
  message: nodeOrStringProp,
  /**
  LoadingSpinner smaller
   */
  size: PropTypes.string,
  /**
  Lighter LoadingSpinner message
   */
  messageMuted: PropTypes.bool,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map
